export enum AdminLevel {
  MODERATOR = "moderator",
  BILLING_MANAGER = "billing_manager",
  SUPER_ADMIN = "super_admin",
}